import { useDatasourceId, useQueryId, useSeriesId } from '@/hooks';
import { useGetQueryAvailableChartsQuery } from '@/features/queryMetricsDimensionsConfig/apiSlice';
import { useGetAvailableChartTypes } from '@/features/chart-configuration/hooks';
import { useLoadRows } from '@/features/query-builder/hooks';
import { useAppSelector } from '@/store/hooks';
import {
  selectFullResultsSeriesId,
  selectIsFullResultsLoaded,
  selectIsLoadingRows,
} from '@/features/query-builder/queryBuilderSlice';

export const useGetQueryBuilderSummarizeConfig = () => {
  const datasourceId = useDatasourceId();
  const seriesId = useSeriesId();
  const fullResultsSeriesId = useAppSelector(selectFullResultsSeriesId);
  const isFullResultsLoaded = useAppSelector(selectIsFullResultsLoaded);
  const areRowsReady = !useAppSelector(selectIsLoadingRows);
  const browserQueryId = useQueryId();
  const { data: rowsData } = useLoadRows();

  const queryId =
    fullResultsSeriesId && isFullResultsLoaded
      ? browserQueryId
      : rowsData?.queryId;

  const { data: queryChartData, isSuccess: isQueryDataChartsDataReady } =
    useGetQueryAvailableChartsQuery(
      { datasourceId, queryId },
      {
        skip: !queryId,
      },
    );

  const {
    data: savedQueryChartData,
    isSuccess: isSavedQueryDataChartsDataReady,
  } = useGetAvailableChartTypes(seriesId, !!queryId);

  const data = queryChartData || savedQueryChartData;
  const isReady =
    areRowsReady &&
    (queryId ? isQueryDataChartsDataReady : isSavedQueryDataChartsDataReady);

  return { data, isReady };
};
